import FadeIn from 'legacy/common/components/transition/FadeIn';
import React from 'react';
import PromoterDiscount from '../PromoterDiscount';
import InfoTooltip from 'legacy/common/components/wysiwyg-form/InfoTooltip';

interface AdvanceOptionsProps {
  setShowAdvanceOptions: (show: boolean) => void;
  eventId: string;
}

const rules = {
  '1': 'If a purchaser uses a discount and pays less than the original amount, the promoter kickback will be based on the final purchase total.',
  '2': 'If a discount lowers the ticket price below the promoter payout, your account will be debited to cover the difference.'
};

const tooltipMessage = `1. ${rules[1]} 2. ${rules[2]}`;

const AdvanceOptions = ({
  setShowAdvanceOptions,
  eventId
}: AdvanceOptionsProps) => (
  <FadeIn>
    <div>
      <div
        onClick={() => setShowAdvanceOptions(false)}
        className="text-sm font-bold text-[#3853C4] cursor-pointer"
      >
        Hide advance options
      </div>
      <div className="mt-10">
        <div className="items-center justify-start flex">
          <div className="text-base font-bold text-[#202020]">
            Include a Discount
          </div>
          <InfoTooltip id="tooltip" message={tooltipMessage} position="top" />
        </div>
        <div className="mt-2 text-[#575757] text-sm font-normal">
          Give your promoters a boost with a discount for people who use their
          link or code. It is an easy way to sell more tickets while allowing
          you to track their success.
        </div>
      </div>
      <PromoterDiscount eventId={eventId} />
    </div>
  </FadeIn>
);

export default AdvanceOptions;
